import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./login.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getFormObj, server_domain } from "../../services/constants";
import { post } from "../../services/axios";
import { login } from "../../redux/authSlice";
import { cart } from "../../redux/cartSlice";
import { favorite } from "../../redux/favoriteSlice";
import { setError } from "../../redux/appsettingSlice";
import { AutoVideo } from "../../Components/AutoVideo";
import { Agreements } from "../../Components/Agreements";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const loginContent = useSelector((state) => state.appsetting.login_content);
  const headerVideo = loginContent.header_videoISfile;

  const [emailFocus, setEmailFocus] = useState(false);
  const [passwordFocus, setPasswordFocus] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const getFavorites = useCallback(
    async (user_id) => {
      const formData = getFormObj();
      formData.append("api_method", "list_app_favorites");
      formData.append("user_id", user_id);
      try {
        const response = await post(server_domain, formData);
        const favorCnt =
          response.data.message === "SUCCESS" && response.data.list.length > 0
            ? response.data.no_of_records
            : 0;
        dispatch(favorite({ counts: favorCnt }));
      } catch (err) {
        console.error(err);
        dispatch(favorite({ counts: 0 }));
      }
    },
    [dispatch]
  );

  const getOrdersItems = useCallback(
    async (user_id) => {
      const formData = getFormObj();
      formData.append("api_method", "get_cart");
      formData.append("user_id", user_id);

      try {
        const response = await post(server_domain, formData);
        const ordersItems =
          response.data.message === "SUCCESS"
            ? response.data.cart.items || []
            : [];
        dispatch(cart({ items: ordersItems }));
      } catch (err) {
        console.error(err);
        dispatch(cart({ items: [] }));
      }
    },
    [dispatch]
  );

  const handleLogin = useCallback(
    async (email, password, first_name = "", last_name = "") => {
      const formData = getFormObj();
      formData.append("api_method", "login");
      formData.append("login_email", email);
      formData.append("login_password", password);
      formData.append("first_name", first_name);
      formData.append("last_name", last_name);

      try {
        const loginResponse = await post(server_domain, formData);
        if (loginResponse.data.success === 1) {
          const user_id = loginResponse.data.user_id;
          const user = { email, user_id };
          dispatch(login({ isAuthenticated: true, user }));
          await Promise.all([getOrdersItems(user_id), getFavorites(user_id)]);
          localStorage.setItem("isAuthenticated", "done");
          localStorage.setItem("user", JSON.stringify(user));
          navigate(from, { replace: true });
          dispatch(
            setError({
              isShow: true,
              alert_title: "",
              alert_text: loginResponse.data.alert_text,
              message: loginResponse.data.alert_title,
            })
          );
        } else {
          dispatch(
            setError({
              isShow: true,
              alert_title: "Error",
              message: loginResponse.data.error,
            })
          );
        }
      } catch (err) {
        console.error(err);
        dispatch(
          setError({
            isShow: true,
            alert_title: "Error",
            message: err.toString(),
          })
        );
      }
    },
    [dispatch, navigate, from, getFavorites, getOrdersItems]
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const emailParam = urlParams.get("email");
    const token = urlParams.get("token");
    const first_name = urlParams.get("first_name");
    const last_name = urlParams.get("last_name");
    if (emailParam && token && first_name && last_name) {
      handleLogin(emailParam, token, first_name, last_name);
    }
  }, [handleLogin]);

  const onFocusEmail = (field) => {
    if (field === "email") {
      setEmailFocus(!emailFocus);
    } else {
      setPasswordFocus(!passwordFocus);
    }
  };

  const handlerSubmit = (e) => {
    e.preventDefault();
    handleLogin(email, password);
  };

  return (
    <div className="login-div">
      <div className="main-background">
        <div className="login-form reveal fade-in active">
          <form onSubmit={handlerSubmit}>
            <div className={`email ${emailFocus ? "emailFocus" : ""}`}>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 0 24 24"
                  width="24px"
                  fill="#525252"
                >
                  <path d="M0 0h24v24H0V0z" fill="none" />
                  <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" />
                </svg>
              </span>
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onFocus={() => onFocusEmail("email")}
                onBlur={() => onFocusEmail("email")}
                className="email-input"
              />
            </div>
            <div className={`password ${passwordFocus ? "passwordfocus" : ""}`}>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 0 24 24"
                  width="24px"
                  fill="#525252"
                >
                  <g fill="none">
                    <path d="M0 0h24v24H0V0z" />
                    <path d="M0 0h24v24H0V0z" opacity=".87" />
                  </g>
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" />
                </svg>
              </span>
              <input
                type="password"
                name="password"
                placeholder="Password"
                className="password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={() => onFocusEmail("password")}
                onBlur={() => onFocusEmail("password")}
              />
            </div>
            <div className="reset-pass">
              <Link to="/resetpassword">Password Reset</Link>
            </div>
            <div className="buttonlogin">
              <button className="login-btn" type="submit">
                Login
              </button>
            </div>
          </form>
          <Agreements />
          <div className="signup-text">
            Don't have an account? <Link to="/signup">Sign Up</Link>
          </div>
        </div>
      </div>
      <div className="video-login">
        <AutoVideo
          className="loginvideo reveal fade-in active"
          src={headerVideo}
        />
      </div>
    </div>
  );
}

export default Login;
